/**
 * @file     vowOAuthIntent.ts
 * @purpose  Remembers, across the Google or Apple round trip, that the person
 *           left from the VOW modal. Session storage: the round trip stays in
 *           one tab, and an abandoned attempt dies with it.
 */
'use client';

const KEY = 'relta_vow_oauth_intent';

export function markVowOAuthIntent() {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    /* storage blocked: the person reopens the gate themselves */
  }
}

export function hasVowOAuthIntent(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearVowOAuthIntent() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
